import { Trans } from "@lingui/react/macro";

// Игрок скрыл себя из сравнения: таблицы и номинаций нет, напарники и приглашения — есть.
export const HiddenNotice = () => (
  <section className="flex flex-col gap-1 rounded-xl border border-dashed border-border-strong bg-surface px-5 py-4.5">
    <p className="text-[17px] font-semibold">
      <Trans>You're hidden from comparison</Trans>
    </p>
    <p className="text-sm text-muted">
      <Trans>
        Friends don't see you in their tables, and you don't see them. Mates and invites work as
        usual. You can turn showing back on at the bottom of the page.
      </Trans>
    </p>
  </section>
);
